import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.sales-plan',
    method: 'get',
    params,
  })
}

export const listAll = (params?: any) => {
  return axiosService({
    url: '/api.sales-plan/all',
    method: 'get',
    params,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.sales-plan/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.sales-plan/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.sales-plan/${id}`,
    method: 'put',
    data,
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.sales-plan/${id}/reject`,
    method: 'put',
    data,
  })
}

export const approve = (id: number, data: any = {}) => {
  return axiosService({
    url: `/api.sales-plan/${id}/approve`,
    method: 'put',
    data,
  })
}

export const apply = (id: number) => {
  return axiosService({
    url: `/api.sales-plan/${id}/apply`,
    method: 'put',
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.sales-plan/${id}/remake`,
    method: 'put',
    data,
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.sales-plan/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.sales-plan',
    method: 'post',
    data,
  })
}
